import {
  NamedValueEncoder1lca9edk1lf89 as NamedValueEncoder,
  NamedValueDecoderzk26ztf92xbq as NamedValueDecoder,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Tagged.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer,
  findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer_0,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  LIST_getInstancey7k5h8d5cvxt as LIST_getInstance,
  MAP_getInstance3s1t6byguxmp9 as MAP_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  toBoolean2azvnq2ukl7b3 as toBoolean,
  toByte1ihbgyfg5m688 as toByte,
  toShort1i0zdidogv7z as toShort,
  toInt2q8uldh7sc951 as toInt,
  toLongkk4waq8msp1k as toLong,
  toDouble1kn912gjoizjp as toDouble,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { single29ec4rh52687r as single } from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var OutMapperClass;
function OutMapper() {
  if (OutMapperClass === VOID) {
    class $ extends NamedValueEncoder() {
      constructor($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.j4z_1 = $outer;
        super($box);
        this.h4z_1 = this.j4z_1.mz();
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.i4z_1 = LinkedHashMap().f6();
      }
      mz() {
        return this.h4z_1;
      }
      nz(serializer, value) {
        if (serializer instanceof AbstractPolymorphicSerializer()) {
          var casted = serializer instanceof AbstractPolymorphicSerializer() ? serializer : THROW_CCE();
          var actualSerializer = findPolymorphicSerializer(casted, this, !(value == null) ? value : THROW_CCE());
          this.d1j(this.u1h('type'), actualSerializer.az().h10());
          return actualSerializer.oz(this, value);
        }
        return serializer.oz(this, value);
      }
      m4z(tag, value) {
        var tmp0 = this.i4z_1;
        // Inline function 'kotlin.collections.set' call
        var value_0 = this.l4z(value);
        tmp0.s3(tag, value_0);
      }
      s1i(tag, value) {
        return this.m4z((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
      }
      n4z(tag) {
      }
      u1i(tag) {
        return this.n4z((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      o4z(tag, enumDescriptor, ordinal) {
        var tmp0 = this.i4z_1;
        // Inline function 'kotlin.collections.set' call
        var value = this.l4z(enumDescriptor.v11(ordinal));
        tmp0.s3(tag, value);
      }
      e1j(tag, enumDescriptor, ordinal) {
        return this.o4z((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor, ordinal);
      }
    }
    initMetadataForClass($, 'OutMapper');
    OutMapperClass = $;
  }
  return OutMapperClass;
}
var OutStringMapperClass;
function OutStringMapper() {
  if (OutStringMapperClass === VOID) {
    class $ extends OutMapper() {
      constructor($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.t4z_1 = $outer;
        super($outer, $box);
      }
      l4z(value) {
        return toString(value);
      }
    }
    initMetadataForClass($, 'OutStringMapper');
    OutStringMapperClass = $;
  }
  return OutStringMapperClass;
}
var InMapperClass;
function InMapper() {
  if (InMapperClass === VOID) {
    class $ extends NamedValueDecoder() {
      constructor($outer, map, descriptor, $box) {
        if ($box === VOID)
          $box = {};
        $box.b50_1 = $outer;
        super($box);
        this.w4z_1 = map;
        this.x4z_1 = this.b50_1.mz();
        this.y4z_1 = 0;
        this.z4z_1 = equals(descriptor.s11(), LIST_getInstance()) || equals(descriptor.s11(), MAP_getInstance());
        this.a50_1 = this.z4z_1 ? 2147483647 : descriptor.u11();
      }
      mz() {
        return this.x4z_1;
      }
      l13(descriptor) {
        // Inline function 'kotlin.also' call
        var this_0 = this.c50(descriptor);
        this.o1i(this_0);
        return this_0;
      }
      qz(deserializer) {
        if (deserializer instanceof AbstractPolymorphicSerializer()) {
          var tmp0_safe_receiver = this.w4z_1.p3(this.u1h('type'));
          var type = tmp0_safe_receiver == null ? null : toString(tmp0_safe_receiver);
          var actualSerializer = findPolymorphicSerializer_0(deserializer, this, type);
          var tmp = actualSerializer.pz(this);
          return !(tmp == null) ? tmp : THROW_CCE();
        }
        return deserializer.pz(this);
      }
      d50(tag) {
        return getValue(this.w4z_1, tag);
      }
      a1i(tag) {
        return this.d50((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      d2g(tag, enumDescriptor) {
        var taggedValue = getValue(this.w4z_1, tag);
        var tmp;
        if (typeof taggedValue === 'number') {
          tmp = taggedValue;
        } else {
          if (typeof taggedValue === 'string') {
            // Inline function 'kotlin.also' call
            var this_0 = enumDescriptor.w11(taggedValue);
            if (this_0 === -3)
              throw SerializationException().p10("Enum '" + enumDescriptor.h10() + "' does not contain element with name '" + toString(taggedValue) + "'");
            tmp = this_0;
          } else {
            throw SerializationException().p10("Value of enum entry '" + tag + "' is neither an Int nor a String");
          }
        }
        return tmp;
      }
      l1i(tag, enumDescriptor) {
        return this.d2g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
      }
      b14(descriptor) {
        $l$loop: while (this.y4z_1 < this.a50_1) {
          var _unary__edvuaz = this.y4z_1;
          this.y4z_1 = _unary__edvuaz + 1 | 0;
          var name = this.s1h(descriptor, _unary__edvuaz);
          var tmp0 = this.w4z_1.q3();
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (startsWith(element, name) && (element.length === name.length || charCodeAt(element, name.length) === _Char___init__impl__6a9atx(46))) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          if (tmp$ret$0)
            return this.y4z_1 - 1 | 0;
          if (this.z4z_1) {
            break $l$loop;
          }
        }
        return -1;
      }
    }
    initMetadataForClass($, 'InMapper');
    InMapperClass = $;
  }
  return InMapperClass;
}
var InStringMapperClass;
function InStringMapper() {
  if (InStringMapperClass === VOID) {
    class $ extends InMapper() {
      constructor($outer, map, descriptor, $box) {
        if ($box === VOID)
          $box = {};
        $box.m50_1 = $outer;
        super($outer, map, descriptor, $box);
      }
      c50(descriptor) {
        return new (InStringMapper())(this.m50_1, this.w4z_1, descriptor);
      }
      f2g(tag) {
        return toBoolean(this.d50(tag));
      }
      c1i(tag) {
        return this.f2g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      g2g(tag) {
        return toByte(this.d50(tag));
      }
      d1i(tag) {
        return this.g2g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      h2g(tag) {
        return toShort(this.d50(tag));
      }
      e1i(tag) {
        return this.h2g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      i2g(tag) {
        return toInt(this.d50(tag));
      }
      f1i(tag) {
        return this.i2g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      j2g(tag) {
        return toLong(this.d50(tag));
      }
      g1i(tag) {
        return this.j2g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      k2g(tag) {
        // Inline function 'kotlin.text.toFloat' call
        var this_0 = this.d50(tag);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return toDouble(this_0);
      }
      h1i(tag) {
        return this.k2g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      l2g(tag) {
        return toDouble(this.d50(tag));
      }
      i1i(tag) {
        return this.l2g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      m2g(tag) {
        return single(this.d50(tag));
      }
      j1i(tag) {
        return this.m2g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
    }
    initMetadataForClass($, 'InStringMapper');
    InStringMapperClass = $;
  }
  return InStringMapperClass;
}
var DefaultClass;
function Default() {
  if (DefaultClass === VOID) {
    class $ extends Properties() {
      constructor() {
        Default_instance = null;
        super(EmptySerializersModule(), null);
        Default_instance = this;
      }
    }
    initMetadataForObject($, 'Default');
    DefaultClass = $;
  }
  return DefaultClass;
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new (Default())();
  return Default_instance;
}
var PropertiesClass;
function Properties() {
  if (PropertiesClass === VOID) {
    class $ {
      constructor(serializersModule, ctorMarker) {
        Default_getInstance();
        this.k4z_1 = serializersModule;
      }
      mz() {
        return this.k4z_1;
      }
      n50(serializer, value) {
        var m = new (OutStringMapper())(this);
        m.nz(serializer, value);
        return m.i4z_1;
      }
      o50(deserializer, map) {
        var m = new (InStringMapper())(this, map, deserializer.az());
        return m.qz(deserializer);
      }
    }
    initMetadataForClass($, 'Properties');
    PropertiesClass = $;
  }
  return PropertiesClass;
}
function Properties_0(module_0) {
  return new (PropertiesImpl())(module_0);
}
var PropertiesImplClass;
function PropertiesImpl() {
  if (PropertiesImplClass === VOID) {
    class $ extends Properties() {
      constructor(serializersModule) {
        super(serializersModule, null);
      }
    }
    initMetadataForClass($, 'PropertiesImpl');
    PropertiesImplClass = $;
  }
  return PropertiesImplClass;
}
//region block: exports
export {
  Properties_0 as Properties3rdc3388jbgie,
};
//endregion

//# sourceMappingURL=Properties.mjs.map
